import React, { useState } from "react";
import { Container } from "./styles";
import useClickedOutside from "../../../../../hooks/useClickedOutside";
import InlineSVG from "react-inlinesvg/esm";
import { CANVAS_OUTLINE_BEATS } from "../../../../../../../src/shared/canvasConstants";
import CopyToClipboard from "react-copy-to-clipboard";

const Menu = ({ cardIds, cards }) => {
  const [open, setOpen] = useState(false);
  const ref = useClickedOutside(() => {
    setOpen(false);
  });

  const header = cards[cardIds[0]];
  const beats = CANVAS_OUTLINE_BEATS[header.data.type];

  const text = cardIds
    .map((id, i) => {
      const card = cards[id];

      if (i === 0) {
        return card.content;
      } else {
        return `${beats[card.data.beatId].title}\n${card.content}`;
      }
    })
    .join("\n");

  return (
    <Container ref={ref}>
      <a
        onClick={(e) => setOpen(!open)}
        className="hotdog-dots"
      >
        <InlineSVG src="/assets/hotdog-menu.svg" />
      </a>

      {open && (
        <ul className="menu">
          <li>
            <CopyToClipboard
              text={text}
              onCopy={() => {
                setOpen(false);
              }}
              options={{ format: "text/plain" }}
            >
              <a>Copy Outline to Clipboard</a>
            </CopyToClipboard>
          </li>
        </ul>
      )}
    </Container>
  );
};

export default Menu;
